import logEvent from "app/assets/javascripts/tracking/amplitude/log-event"
import { googletag } from "./shared"

const updateAdContainerStatus = (container, isFilled) => {
  if (isFilled) {
    container.classList.remove("unfilled")
    container.classList.add("filled")
  } else {
    container.classList.add("unfilled")
    container.classList.remove("filled")
  }
}

googletag.cmd.push(function () {
  googletag.pubads().addEventListener("slotRenderEnded", function (event) {
    const slot = event.slot
    const id = slot.getSlotElementId()

    const element = document.getElementById(id)
    if (element) {
      const container = document.getElementById(`${id}-container`)

      if (event.isEmpty) {
        updateAdContainerStatus(container, false)
        logEvent("fallback_ad")
      } else {
        updateAdContainerStatus(container, true)
      }
    }
  })

  googletag.pubads().addEventListener("slotOnload", function (event) {
    const slot = event.slot
    const id = slot.getSlotElementId()
  })
})
